import React from "react";
import RichInputControls, {
  TRichInputControlsItem,
} from "@atlas/uicorn/lib/Control/RichInputControls";
import styles from "../styles/form-rich-input.module.css";
import UiRichInput, {
  TRichInputProps,
} from "@atlas/uicorn/lib/Input/RichInput";

const FormRichInput = function FormRichInput(
  props: Pick<TRichInputProps, "defaultValue" | "onChange">
) {
  return (
    <UiRichInput {...props} placeholder="Add your message...">
      {(children) => (
        <div className={styles.inputContainer}>
          <RichInputControls
            className={styles.richInputControls}
            items={controlItems}
          />
          {children}
        </div>
      )}
    </UiRichInput>
  );
};

export default FormRichInput;

export const controlItems: TRichInputControlsItem[] = [
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "code",

  "block-quote",
  "heading-one",
  "heading-two",
  "numbered-list",
  "bulleted-list",
];
